import React from "react";
import { Tooltip } from "@blueprintjs/core";
import { techToImage } from "../../../constants";
import styled from "styled-components";

const LangImg = styled.img`
  max-height: 20px;
  max-width: 20px;
  vertical-align: middle;
`;

const StyledTooltip = styled(Tooltip)<{ large: boolean }>`
  padding-right: ${(props) => (props.large ? "16px" : "8px")};
  :last-child {
    padding-right: 0;
  }
`;

const LanguagesCell: React.FC<{ languages: string[]; large?: boolean }> = ({
  languages,
  large = false,
}) => {
  return (
    <div>
      {languages.map((lang, idx) => (
        <StyledTooltip key={idx} content={lang} large={large}>
          {techToImage[lang.toLowerCase()] ? (
            <LangImg // nosem: typescript.react.security.audit.react-http-leak.react-http-leak
              src={techToImage[lang.toLowerCase()]}
              alt={lang}
            />
          ) : (
            <span>{lang}</span>
          )}
        </StyledTooltip>
      ))}
    </div>
  );
};

export default LanguagesCell;
